/*
	CHARACTERS
*/
//------------------------------------------------------------
// IMPORT
//------------------------------------------------------------

import Character from './Character.js';

//------------------------------------------------------------
// MAINS
//------------------------------------------------------------

const ATOM = new Character({
	firstName: 'Adam',
	lastName: 'Haskell',
	ICU: {
	    screenName: 'ATOM',
	    status: 'away'
	}
});

const ELVIE = new Character({
	firstName: 'Michelle',
	lastName: 'Haskell',
	ICU: {
	    screenName: 'Elvie',
	    status: 'do-not-disturb'
	}
});

const FROSTBYTE = new Character({
	firstName: 'Ernie',
	lastName: 'Frost',
	ICU: {
	    screenName: 'FROST_BYTE',
	    status: 'na'
	}
});

const GWENDOLYN = new Character({
	firstName: 'Gwendolyn',
	lastName: '',
	ICU: {
	    screenName: 'gwendolyn',
	    status: 'online'
	}
});

const JERICHO = new Character({
	firstName: 'Jerry',
	lastName: 'Cheng',
	ICU: {
	    screenName: '~JERICHØ~',
	    status: 'na'
	}
});

const SUTRA_NOVA = new Character({
	firstName: 'Adam',
	lastName: 'Haskell',
	ICU: {
	    screenName: 'Sutra Nova',
	    status: 'free-for-chat'
	}
});

//------------------------------------------------------------
// SIDES
//------------------------------------------------------------

const AJ = new Character({
	ICU: {
	    screenName: 'AJ'
	}
});

const KLOUDI = new Character({
	ICU: {
	    screenName: 'Kloudi'
	}
});

const MIKE_CULLEN = new Character({
	ICU: {
	    screenName: 'mike cullen'
	}
});

const GROOVY_CHICK = new Character({
	ICU: {
	    screenName: 'Groovy Chick'
	}
});

const MERRY_CHRISTMAS = new Character({
	ICU: {
	    screenName: 'Happy Birthday Jesus †'
	}
});

const CYBER_FELON = new Character({
	ICU: {
	    screenName: '[.404]CyberFelon'
	}
});

//------------------------------------------------------------
// EXPORTS
//------------------------------------------------------------

export default [
	ATOM,
	ELVIE,
	FROSTBYTE,
	GWENDOLYN,
	JERICHO,
	SUTRA_NOVA,

	AJ,
	KLOUDI,
	MIKE_CULLEN,
	GROOVY_CHICK,
	MERRY_CHRISTMAS,
	CYBER_FELON
]